import { Church, Heart, Dumbbell, Coins, PartyPopper } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const VALUES = [
  { name: "Faith", icon: Church, line: "The foundation every decision stands on." },
  { name: "Family", icon: Heart, line: "The reason legacy matters at all." },
  { name: "Fitness", icon: Dumbbell, line: "Discipline of body builds discipline of mind." },
  { name: "Finance", icon: Coins, line: "Stewardship engineered with precision." },
  { name: "Fun", icon: PartyPopper, line: "A wealthy life is meant to be enjoyed." },
];

export const CoreValues = () => (
  <section id="values" data-testid="core-values-section" className="relative overflow-hidden bg-[#0F091A] py-28 lg:py-36">
    <div
      className="absolute left-0 top-1/3 h-[24rem] w-[24rem] rounded-full bg-[#2E1065]/40 blur-[140px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="eyebrow mb-6" data-testid="values-eyebrow">Core Values</p>
        <h2 className="max-w-2xl font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Five pillars.
          <span className="text-gold-gradient"> One life well built.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {VALUES.map((v, i) => {
          const Icon = v.icon;
          return (
            <Reveal key={v.name} delay={i * 0.08}>
              <div
                className="gold-border-glow group flex h-full flex-col items-start bg-wine/70 p-7"
                data-testid={`value-card-${v.name.toLowerCase()}`}
              >
                <span className="flex h-11 w-11 items-center justify-center border border-gold/30 bg-royal/60 text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-obsidian">
                  <Icon size={18} strokeWidth={1.5} />
                </span>
                <span className="mt-6 font-display text-2xl font-semibold text-white">{v.name}</span>
                <span className="mt-3 text-sm leading-relaxed text-white/50">{v.line}</span>
                <span className="mt-auto pt-6 font-mono text-[10px] uppercase tracking-[0.3em] text-gold/50">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
